let readyProductPair = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

readyProductPair(() => {
  createOptionBundle = (productPair, formAddToCart) => {
    let productSelect = formAddToCart.querySelector('#product-select'),
      productPairBundle = productPair.querySelector('#product-pair--bundle');

    if (productSelect && productPairBundle && productPairBundle.disabled === false) {
      let optionBundle = document.createElement('option');
      optionBundle.id = productPairBundle.dataset.variantId;
      optionBundle.value = productPairBundle.dataset.variantId;
      optionBundle.dataset.qty = productPairBundle.dataset.qty;
      optionBundle.innerHTML = productPairBundle.dataset.variantTitle;
      productSelect.appendChild(optionBundle);
    }
  };

  eventListeners = (productPair) => {
    let productPairBundle = productPair.querySelector('#product-pair--bundle');

    if (productPairBundle) {
      productPairBundle.addEventListener('change', (e) => {
        console.log('Product pair changed');
        changeProductPair(e.target);
      });
    }
  };

  changeProductPair = (target) => {
    let productPair = target.closest('.product-pair'),
      productPairBundle = productPair.querySelector('#product-pair--bundle'),
      formAddToCart = document.querySelector('#add-to-cart'),
      productSelect = formAddToCart.querySelector('#product-select'),
      purpose = formAddToCart.querySelector('[name="properties[Purpose]"]'),
      thumbnail = formAddToCart.querySelector('[name="properties[_Thumbnail]"]');

    if (productPairBundle.checked === false) {
      productSelect.value = productSelect.dataset.singleVariantId;
      if (purpose) purpose.value = purpose.dataset.singlePurpose;
      if (thumbnail) thumbnail.value = thumbnail.dataset.singleThumbnail;

      const event = new CustomEvent('variant-pair:selected', {
        bubbles: true,
        composed: true,
        detail: { variantId: productSelect.dataset.singleVariantId, isChecked: productPairBundle.checked },
      });
      productSelect.dispatchEvent(event);
      productSelect.dispatchEvent(new Event('change'));
    } else {
      productSelect.dataset.singleVariantId = productSelect.value;
      productSelect.value = productPairBundle.dataset.variantId;

      if (purpose) {
        purpose.dataset.singlePurpose = purpose.value;
        purpose.value = productPairBundle.dataset.purpose;
      }
      if (thumbnail) {
        thumbnail.dataset.singleThumbnail = thumbnail.value;
        thumbnail.value = productPairBundle.dataset.thumbnail;
      }
      const event = new CustomEvent('variant-pair:selected', {
        bubbles: true,
        composed: true,
        detail: { variantId: productPairBundle.dataset.variantId, isChecked: productPairBundle.checked },
      });
      productSelect.dispatchEvent(event);
      productSelect.dispatchEvent(new Event('change'));
    }
  };

  let productPair = document.querySelector('.product-pair'),
    formAddToCart = document.querySelector('#add-to-cart');

  if ((productPair) && formAddToCart) {
    // Create the option for the bundle in the select dropdown
    createOptionBundle(productPair, formAddToCart);
    productPair && eventListeners(productPair);
  }
});
